"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _luxon = require("luxon");

var _chartUtils = require("../../chartUtils");

var _readingsToCoordinates = require("../../transformers/readingsToCoordinates");

var _RecentPerformanceCrosshair = require("../RecentPerformanceCrosshair");

var _ChartStyles = require("../ChartStyles");

var _Display = _interopRequireDefault(require("./Display"));

var _Interaction = _interopRequireDefault(require("./Interaction"));

var _Controls = _interopRequireDefault(require("./Controls"));

var _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var transformToBatteryAveragePercentageCoordinates = (0, _memoizeOne["default"])(function (readings, timeZone) {
  return readings.filter((0, _chartUtils.isValidReading)('averageBatteryPercentageState')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'averageBatteryPercentageState'));
});

var BatteryPercentageChart = function BatteryPercentageChart(_ref) {
  var batteryReadings = _ref.batteryReadings,
      isLoading = _ref.isLoading,
      storageProfile = _ref.storageProfile,
      timeZone = _ref.timeZone,
      viewEndISO = _ref.viewEndISO,
      viewStartISO = _ref.viewStartISO;

  var _useState = (0, _react.useState)('Battery 1'),
      _useState2 = _slicedToArray(_useState, 2),
      focusedBattery = _useState2[0],
      _setFocusedBattery = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isToggleActive = _useState4[0],
      setToggle = _useState4[1];

  var individualBatteryKeys = Object.keys(batteryReadings).filter(function (b) {
    return b !== 'averageBatteryReadings';
  });

  var viewEndDateTime = _luxon.DateTime.fromISO(viewEndISO, {
    zone: timeZone
  });

  var viewStartDateTime = _luxon.DateTime.fromISO(viewStartISO, {
    zone: timeZone
  });

  var startMillis = viewStartDateTime.toMillis();
  var endMillis = viewEndDateTime.toMillis();
  var averageBatteryCoordinates = transformToBatteryAveragePercentageCoordinates(batteryReadings.averageBatteryReadings, timeZone);
  var individualBatteryCoordinates = individualBatteryKeys.reduce(function (obj, key) {
    // eslint-disable-next-line no-param-reassign
    obj[key] = _this.transformToBatteryAveragePercentageCoordinates(batteryReadings[key], timeZone);
    return obj;
  }, {});
  var coordinatesGroupedByTime = (0, _RecentPerformanceCrosshair.groupCoordinatesByTime)(_objectSpread({
    average: averageBatteryCoordinates
  }, individualBatteryCoordinates));
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Controls["default"], {
    individualBatteryKeys: individualBatteryKeys,
    isToggleActive: isToggleActive,
    setToggleState: function setToggleState() {
      return setToggle(!isToggleActive);
    },
    storageProfile: storageProfile
  }), /*#__PURE__*/_react["default"].createElement(_ChartStyles.MainChartWrapper, null, /*#__PURE__*/_react["default"].createElement(_Display["default"], {
    averageBatteryCoordinates: averageBatteryCoordinates,
    endMillis: endMillis,
    focusedBattery: focusedBattery,
    isLoading: isLoading,
    individualBatteryCoordinates: individualBatteryCoordinates,
    individualBatteryKeys: individualBatteryKeys,
    isToggleActive: isToggleActive,
    startMillis: startMillis,
    timeZone: timeZone
  }), /*#__PURE__*/_react["default"].createElement(_ChartStyles.FillAvailableSpace, null, /*#__PURE__*/_react["default"].createElement(_Interaction["default"], {
    coordinatesGroupedByTime: coordinatesGroupedByTime,
    endMillis: endMillis,
    focusedBattery: focusedBattery,
    individualBatteryCoordinates: individualBatteryCoordinates,
    individualBatteryKeys: individualBatteryKeys,
    isToggleActive: isToggleActive,
    setFocusedBattery: function setFocusedBattery(b) {
      return _setFocusedBattery(b);
    },
    startMillis: startMillis,
    timeZone: timeZone
  }))));
};

BatteryPercentageChart.propTypes = {
  batteryReadings: _propTypes["default"].shape({
    averageBatteryReadings: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      averageBatteryPercentageState: _propTypes["default"].number,
      energyChargedKwh: _propTypes["default"].number,
      energyDischargedKwh: _propTypes["default"].number,
      maxBatteryPercentageState: _propTypes["default"].number,
      minBatteryPercentageState: _propTypes["default"].number,
      readingEndTimeLocal: _propTypes["default"].string,
      startDateUtc: _propTypes["default"].string
    })),
    individualBatteryReadings: _propTypes["default"].shape({
      'Battery 1': _propTypes["default"].arrayOf(_propTypes["default"].shape({
        averageBatteryPercentageState: _propTypes["default"].number,
        energyChargedKwh: _propTypes["default"].number,
        energyDischargedKwh: _propTypes["default"].number,
        maxBatteryPercentageState: _propTypes["default"].number,
        minBatteryPercentageState: _propTypes["default"].number,
        readingEndTimeLocal: _propTypes["default"].string,
        startDateUtc: _propTypes["default"].string
      }))
    })
  }),
  isLoading: _propTypes["default"].bool,
  storageProfile: _propTypes["default"].shape({
    storageMode: _propTypes["default"].string,
    storageProfileDetails: _propTypes["default"].shape({
      name: _propTypes["default"].string
    })
  }).isRequired,
  timeZone: _propTypes["default"].string,
  viewEndISO: _propTypes["default"].string.isRequired,
  viewStartISO: _propTypes["default"].string.isRequired
};
BatteryPercentageChart.defaultProps = {
  batteryReadings: {
    averageBatteryReadings: [],
    individualBatteryReadings: {}
  },
  isLoading: false,
  timeZone: 'local'
};
var _default = BatteryPercentageChart;
exports["default"] = _default;